module.exports = __webpack_public_path__ + "static/media/Sarabun-Bold.6173018c.ttf";